import { create } from "zustand";

export type Perfil = "funcionario" | "suporte" | "gestor" | "admin" | "cliente";

export type User = {
  id: string;
  nome: string;
  email: string;
  perfil: Perfil;
  clienteId?: string | null;
  fotoUrl?: string | null;
};

const AUTH_KEY = "growsoft_auth";

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function saveToStorage(user: User | null, token: string | null, refreshToken: string | null) {
  if (user && token) {
    localStorage.setItem(AUTH_KEY, JSON.stringify({ user, token, refreshToken }));
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem("token");
  }
}

const stored = loadFromStorage();

interface AuthState {
  user: User | null;
  token: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string, refreshToken: string) => void;
  logout: () => void;
  can: (roles: string[]) => boolean;
}

export const useAuthStore = create<AuthState>()((set, get) => ({
  user: stored?.user ?? null,
  token: stored?.token ?? null,
  refreshToken: stored?.refreshToken ?? null,
  isAuthenticated: !!stored?.token,

  setAuth: (user, token, refreshToken) => {
    saveToStorage(user, token, refreshToken);
    set({ user, token, refreshToken, isAuthenticated: true });
  },

  logout: () => {
    saveToStorage(null, null, null);
    set({ user: null, token: null, refreshToken: null, isAuthenticated: false });
  },

  can: (roles: string[]) => {
    const user = get().user;
    return user ? roles.includes(user.perfil) : false;
  },
}));
